module.exports = __webpack_public_path__ + "static/map-165a6a99659919d44b2598d3f41d17f0.jpg";